<template lang="pug">
  .div
    .columns.is-vcentered
      .column.is-4
        .field
          label.label Usuario
          TypeaheadUsuario(:options="usuarios" :optionSelect="itemDataUsuario" v-model="usuarioSel" :isDisabled="isTH_disabled")
      .column.is-4.is-top-bottom
        .field
          .file.is-black.has-name
            label.file-label
              input.file-input(type='file' name="fileCotizacion" ref="myCotizacion" @change="previewfileCotizacion" accept="application/pdf")
              span.file-cta
                span.file-icon
                  i.fas.fa-upload
                span.file-label
                  | Archivo&mldr;
              span.file-name
                | {{ fileCotizacion.name }}
      .column.is-4.is-top-bottom
        a.button.is-black.is-rounded(@click="subirCotizacion")
          | Agregar Cotización
    .columns(v-show="verMesg")
      .column.is-offset-2.is-8
        .notification.is-danger
          | {{ mensaje }}
</template>

<script>
  import TypeaheadUsuario from "../../components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"

export default {
    name: 'FormAgregarCotizacion',
    components: { TypeaheadUsuario },
    props: {
      usuarios: {
        type: Array,
        default: [],
      },
      index: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        isTH_disabled: false,
        usuarioSel: {},
        itemDataUsuario: {},
        fileCotizacion: '',
        usuariosShow: [],
        verMesg: false,
        mensaje: '',
        cotizacionObj: {}
      }
    },
    methods: {
      subirCotizacion() {
        console.log('Subir cotizacion')
        console.log(this.fileCotizacion)
        this.cotizacionObj = {}

        if (Object.keys(this.usuarioSel).length > 0 && this.fileCotizacion !== '') {
          this.cotizacionObj = {
            id: this.index,
            idUsuario: this.usuarioSel.id,
            usuario: this.usuarioSel.nombre,
            file: this.fileCotizacion,
            nameFile: this.fileCotizacion.name
          }
          this.$emit('addCotizacion', this.cotizacionObj)
          this.mensaje = ''
          this.verMesg = false
          this.fileCotizacion = ''
        } else {
          this.mensaje = 'No hay usuario y/o falta archivo pdf para poder guardar la cotización.'
          this.verMesg = true
        }
      },
      previewfileCotizacion() {
        let file = this.$refs.myCotizacion.files
        this.fileCotizacion = file[0]
        console.log(this.fileCotizacion)
      },
    },
  }
</script>

<style lang="css" scoped>
  .is-top-bottom {
    margin-top: 32px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/FormAgregarCotizacion.vue